// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Viewmodels
import { ContactPersonVm } from './contactperson.vm';
import { CountryVm } from './country.vm';
import { PartyGenderVm } from './partygender.vm';

import { Type } from 'class-transformer';

export class InsureeVm {
    @AutoMap() ipaId: string;
    @AutoMap() ipaParentId: string;
    @AutoMap() ipaInitials: string;
    @AutoMap() ipaFirstName: string;
    @AutoMap() ipaLastName: string;
    @AutoMap() ipaMaidenName: string;
    @AutoMap(() => PartyGenderVm) ipaPartyGender: PartyGenderVm;
    @AutoMap() @Type(() => Date) ipaDateOfBirth: Date;
    @AutoMap() ipaBsnCitizenServiceNumber: string;
    @AutoMap() ipaPostalCode: string;
    @AutoMap() ipaHouseNumber: string;
    @AutoMap() ipaHouseNumberAddition: string;
    @AutoMap() ipaStreetName: string;
    @AutoMap() ipaCity: string;
    @AutoMap(() => CountryVm) country: CountryVm;
    @AutoMap() ipaPhoneNumber = '';
    @AutoMap() ipaPhoneNumber2 = '';
    @AutoMap() ipaEmail = '';
    @AutoMap() ipaRemarks: string;
    @AutoMap() ipaContactInitiation: string;
    @AutoMap() ipaContactTelephone: string;
    @AutoMap() ipaContactWith: string;
    @AutoMap(() => ContactPersonVm) ContactPersons: ContactPersonVm[];
}